import React from 'react'
import resolveProps from '../../../utils/resolveProps'
import FocusTrap from 'focus-trap-react'
import Button from '../Button'
import { accessibility } from './Modal.stories'

const config = {
  types: [
    {
      title: 'lg',
      isDefault: true
    },
    'sm'
  ],
  modifiers: ['heightAuto']
}
export default function Modal(props) {
  let { data, isOpen, sm, heightAuto, disableFocusTrap, onCloseClick, accessibility, ...rest } = props
  data = data || {}
  onCloseClick = onCloseClick || data.onCloseClick
  isOpen = isOpen || data.isOpen

  const content = <div className="mdn-Modal-content">
    {!accessibility ? (<>
      <div className="mdn-Modal-header">
        {data.header}
        <Button
          icon
          secondary
          {...data.buttonProps}
          onClick={onCloseClick}
          aria-label="Button close modal"
          className="mdn-Button-header-close"
          title="close"
        ></Button>
      </div>
      <div className="mdn-Divider mdn-Divider--primary"></div></>
    ) : null}
    <div className="mdn-Modal-body">{data.content}</div>
    {data.footer ? (
      <div className="mdn-Modal-footer">
        <div className="mdn-Modal-footer-start">
          {data.footer.content}
        </div>
        <div className="mdn-Modal-footer-end">{data.footer.action}</div>
      </div>
    ) : (
      ''
    )}
  </div>

  const renderWithFocusTrap = <FocusTrap
    focusTrapOptions={{
      tabbableOptions: {
        displayCheck: 'none'
      }
    }}
  >
    {content}
  </FocusTrap>

  return (
    <div
      {...rest}
      aria-hidden={isOpen ? 'false' : 'true'}
      className={
        resolveProps(props, config, 'Modal') + (isOpen ? ' mdn-isOpen' : '')
      }
    >
      {isOpen ?
        (
          disableFocusTrap ? content : renderWithFocusTrap
        ) : null}
    </div >
  )
}
